import { render, staticRenderFns } from "./SelectAdminHubAutoClaim.vue?vue&type=template&id=7ad5ccdb&"
import script from "./SelectAdminHubAutoClaim.vue?vue&type=script&lang=js&"
export * from "./SelectAdminHubAutoClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports